import React from 'react';
import { motion } from 'framer-motion';
import { useNavigation } from '../NavigationContext';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  .sg-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .sg-page { font-family: 'Inter', sans-serif; color: #0c1a36; background: #ffffff; width: 100%; }

  /* ── Hero ── */
  .sg-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .sg-hero-blob1 { position: absolute; top: -6%; right: -4%; width: 560px; height: 560px; border-radius: 50%; background: radial-gradient(circle, rgba(14,90,180,0.35), rgba(201,147,26,0.15)); filter: blur(80px); pointer-events: none; }
  .sg-hero-blob2 { position: absolute; bottom: -12%; left: -8%; width: 640px; height: 640px; border-radius: 50%; background: radial-gradient(circle, rgba(12,26,54,0.22), rgba(30,77,140,0.12)); filter: blur(80px); pointer-events: none; }
  .sg-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .sg-hero-inner { grid-template-columns: 1fr; } .sg-hero-visual { display: none; } }

  .sg-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 18px; border-radius: 999px; background: #fef3c7; border: 1px solid #fde68a; font-size: 12.5px; font-weight: 600; color: #92400e; margin-bottom: 28px; }
  .sg-badge-star { color: #d97706; font-size: 13px; }

  .sg-hero h1 { font-size: clamp(1.875rem, 3.75vw, 3rem); font-weight: 900; line-height: 1.1; letter-spacing: -0.03em; color: #0c1a36; margin-bottom: 24px; }
  .sg-gradient-text { background: linear-gradient(135deg, #1e4d8c 0%, #c9931a 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .sg-hero-sub { font-size: 1.12rem; color: #475569; line-height: 1.82; margin-bottom: 40px; font-weight: 400; max-width: 540px; }
  .sg-btn-group { display: flex; gap: 14px; flex-wrap: wrap; }
  .sg-btn-primary { padding: 14px 28px; background: #0c1a36; color: #fff; border: none; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: background 0.2s, transform 0.15s; }
  .sg-btn-primary:hover { background: #1e4d8c; transform: translateY(-1px); }
  .sg-btn-secondary { padding: 14px 28px; background: #fff; color: #334155; border: 1px solid #e2e8f0; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .sg-btn-secondary:hover { border-color: #fde68a; background: #fffbeb; color: #92400e; }

  /* Hero Portal Card */
  .sg-hero-visual { position: relative; }
  .sg-portal-card { background: linear-gradient(150deg, #0c1a36 0%, #1e3a6e 100%); border-radius: 24px; padding: 32px; box-shadow: 0 32px 80px rgba(12,26,54,0.3), 0 4px 16px rgba(0,0,0,0.08); position: relative; overflow: hidden; }
  .sg-portal-dots { position: absolute; inset: 0; opacity: 0.08; background-image: radial-gradient(circle, rgba(255,255,255,0.9) 1px, transparent 0); background-size: 22px 22px; pointer-events: none; }
  .sg-portal-header { display: flex; align-items: center; gap: 10px; margin-bottom: 24px; padding-bottom: 20px; border-bottom: 1px solid rgba(255,255,255,0.1); }
  .sg-portal-logo { width: 36px; height: 36px; background: #c9931a; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
  .sg-portal-title { font-size: 13px; font-weight: 700; color: #fff; }
  .sg-portal-subtitle { font-size: 11px; color: rgba(255,255,255,0.55); margin-top: 1px; }
  .sg-portal-status { margin-left: auto; display: flex; align-items: center; gap: 6px; background: rgba(16,185,129,0.15); border: 1px solid rgba(16,185,129,0.3); border-radius: 999px; padding: 5px 12px; font-size: 11px; font-weight: 600; color: #34d399; }
  .sg-portal-dot { width: 6px; height: 6px; border-radius: 50%; background: #34d399; animation: sg-blink 2s ease-in-out infinite; }
  @keyframes sg-blink { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }

  .sg-portal-field { background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1); border-radius: 12px; padding: 14px 16px; margin-bottom: 10px; }
  .sg-portal-field-label { font-size: 10.5px; font-weight: 600; color: rgba(255,255,255,0.45); letter-spacing: 0.06em; text-transform: uppercase; margin-bottom: 5px; }
  .sg-portal-field-value { font-size: 14px; font-weight: 600; color: #fff; }
  .sg-portal-field-value.verified { color: #34d399; }

  .sg-portal-progress-wrap { margin-top: 20px; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1); border-radius: 16px; padding: 18px 20px; }
  .sg-portal-progress-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
  .sg-portal-progress-label { font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.75); }
  .sg-portal-progress-pct { font-size: 20px; font-weight: 900; color: #c9931a; }
  .sg-progress-bar { height: 8px; background: rgba(255,255,255,0.12); border-radius: 999px; overflow: hidden; }
  .sg-progress-fill { height: 100%; width: 82%; background: linear-gradient(90deg, #c9931a, #f59e0b); border-radius: 999px; }
  .sg-portal-steps { display: flex; gap: 8px; margin-top: 16px; flex-wrap: wrap; }
  .sg-portal-step-chip { padding: 5px 12px; border-radius: 999px; font-size: 11px; font-weight: 600; }
  .sg-portal-step-chip.done { background: rgba(16,185,129,0.15); color: #34d399; border: 1px solid rgba(16,185,129,0.3); }
  .sg-portal-step-chip.active { background: rgba(201,147,26,0.2); color: #fbbf24; border: 1px solid rgba(201,147,26,0.4); }
  .sg-portal-step-chip.pending { background: rgba(255,255,255,0.06); color: rgba(255,255,255,0.4); border: 1px solid rgba(255,255,255,0.1); }

  /* floating badge */
  .sg-floating-badge { position: absolute; bottom: -18px; right: -18px; background: #fff; border-radius: 16px; padding: 14px 18px; box-shadow: 0 16px 48px rgba(12,26,54,0.2); display: flex; align-items: center; gap: 12px; }
  .sg-fb-icon { width: 40px; height: 40px; background: #fef3c7; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
  .sg-fb-label { font-size: 11px; color: #94a3b8; font-weight: 500; }
  .sg-fb-value { font-size: 15px; font-weight: 800; color: #0c1a36; margin-top: 2px; }

  /* ── Stats Bar ── */
  .sg-stats { background: #fff; border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .sg-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .sg-stats-grid { grid-template-columns: 1fr 1fr; } }
  .sg-stat-item { padding: 40px 28px; text-align: center; border-right: 1px solid #f1f5f9; }
  .sg-stat-item:last-child { border-right: none; }
  @media (max-width: 768px) { .sg-stat-item:nth-child(2n) { border-right: none; } .sg-stat-item { border-bottom: 1px solid #f1f5f9; } }
  .sg-stat-num { font-size: 2.4rem; font-weight: 900; color: #1e4d8c; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; }
  .sg-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; line-height: 1.4; }

  /* ── Shared Section Atoms ── */
  .sg-section { padding: 96px 24px; }
  .sg-container { max-width: 1200px; margin: 0 auto; }
  .sg-section-header { text-align: center; max-width: 720px; margin: 0 auto 64px; }
  .sg-section-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0c1a36; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .sg-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.8; }
  .sg-kicker { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #1e4d8c; margin-bottom: 12px; }

  /* ── Services Grid ── */
  .sg-services-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.7); border-bottom: 1px solid rgba(226,232,240,0.7); }
  .sg-services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 960px) { .sg-services-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .sg-services-grid { grid-template-columns: 1fr; } }
  .sg-svc-card { background: #fff; padding: 36px 32px; border-radius: 20px; border: 1px solid rgba(226,232,240,0.8); box-shadow: 0 1px 4px rgba(0,0,0,0.03); transition: all 0.3s; position: relative; overflow: hidden; cursor: pointer; }
  .sg-svc-card:hover { box-shadow: 0 18px 52px rgba(0,0,0,0.1); transform: translateY(-3px); border-color: transparent; }
  .sg-svc-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; opacity: 0; transition: opacity 0.3s; border-radius: 20px 20px 0 0; }
  .sg-svc-card:hover::before { opacity: 1; }
  .sg-svc-card.c-navy::before   { background: linear-gradient(90deg, #0c1a36, #1e4d8c); }
  .sg-svc-card.c-blue::before   { background: linear-gradient(90deg, #1e4d8c, #3b82f6); }
  .sg-svc-card.c-gold::before   { background: linear-gradient(90deg, #c9931a, #f59e0b); }
  .sg-svc-card.c-teal::before   { background: linear-gradient(90deg, #0d9488, #0891b2); }
  .sg-svc-card.c-indigo::before { background: linear-gradient(90deg, #4f46e5, #7c3aed); }
  .sg-svc-card.c-emerald::before { background: linear-gradient(90deg, #059669, #0d9488); }
  .sg-svc-icon { width: 54px; height: 54px; border-radius: 14px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px; font-size: 22px; }
  .sg-svc-icon.c-navy    { background: #eff4ff; }
  .sg-svc-icon.c-blue    { background: #eff6ff; }
  .sg-svc-icon.c-gold    { background: #fef3c7; }
  .sg-svc-icon.c-teal    { background: #f0fdfa; }
  .sg-svc-icon.c-indigo  { background: #eef2ff; }
  .sg-svc-icon.c-emerald { background: #ecfdf5; }
  .sg-svc-card h3 { font-size: 1.08rem; font-weight: 700; color: #0c1a36; margin-bottom: 12px; }
  .sg-svc-card p { font-size: 0.9rem; color: #64748b; line-height: 1.72; margin-bottom: 20px; }
  .sg-svc-tags { display: flex; flex-wrap: wrap; gap: 7px; margin-bottom: 16px; }
  .sg-svc-tag { padding: 4px 11px; font-size: 11px; font-weight: 600; border-radius: 999px; background: rgba(226,232,240,0.6); color: #475569; transition: all 0.2s; }
  .sg-svc-card:hover .sg-svc-tag { background: #eff6ff; color: #1e4d8c; }
  .sg-svc-arrow { display: inline-flex; align-items: center; gap: 5px; font-size: 12.5px; font-weight: 700; color: #1e4d8c; opacity: 0; transform: translateX(-4px); transition: opacity 0.2s, transform 0.2s; }
  .sg-svc-card:hover .sg-svc-arrow { opacity: 1; transform: translateX(0); }

  /* ── Why SAM.gov Matters (dark) ── */
  .sg-why-bg { background: #0c1a36; color: #f8fafc; position: relative; overflow: hidden; }
  .sg-why-glow1 { position: absolute; top: -10%; right: 15%; width: 600px; height: 600px; background: radial-gradient(circle, rgba(201,147,26,0.15), transparent 70%); pointer-events: none; }
  .sg-why-glow2 { position: absolute; bottom: -15%; left: -5%; width: 500px; height: 500px; background: radial-gradient(circle, rgba(30,77,140,0.25), transparent 70%); pointer-events: none; }
  .sg-why-bg .sg-kicker { color: #fbbf24; }
  .sg-why-bg .sg-section-header h2 { color: #fff; }
  .sg-why-bg .sg-section-header p { color: #94a3b8; }
  .sg-why-grid { display: grid; grid-template-columns: 1.1fr 1fr; gap: 80px; align-items: center; }
  @media (max-width: 960px) { .sg-why-grid { grid-template-columns: 1fr; gap: 48px; } }
  .sg-why-left h2 { font-size: clamp(1.9rem, 3.2vw, 2.7rem); font-weight: 800; color: #fff; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 20px; }
  .sg-why-left > p { font-size: 1.02rem; color: #94a3b8; line-height: 1.82; margin-bottom: 44px; }
  .sg-why-list { display: flex; flex-direction: column; gap: 22px; }
  .sg-why-item { display: flex; gap: 16px; align-items: flex-start; }
  .sg-why-icon { flex-shrink: 0; width: 46px; height: 46px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 19px; }
  .sg-why-icon.gold   { background: rgba(201,147,26,0.18); }
  .sg-why-icon.blue   { background: rgba(30,77,140,0.3); }
  .sg-why-icon.green  { background: rgba(5,150,105,0.18); }
  .sg-why-icon.teal   { background: rgba(13,148,136,0.18); }
  .sg-why-item h4 { font-size: 0.98rem; font-weight: 700; color: #fff; margin-bottom: 5px; }
  .sg-why-item p { font-size: 0.87rem; color: #94a3b8; line-height: 1.68; }
  .sg-why-right { display: flex; flex-direction: column; gap: 16px; }
  .sg-why-stat-card { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.08); border-radius: 20px; padding: 26px 28px; transition: border-color 0.3s, background 0.3s; }
  .sg-why-stat-card:hover { border-color: rgba(201,147,26,0.4); background: rgba(255,255,255,0.07); }
  .sg-why-stat-num { font-size: 2.4rem; font-weight: 900; letter-spacing: -0.03em; line-height: 1; margin-bottom: 6px; }
  .sg-why-stat-num.gold { color: #f59e0b; }
  .sg-why-stat-num.blue { color: #60a5fa; }
  .sg-why-stat-num.green { color: #34d399; }
  .sg-why-stat-label { font-size: 0.86rem; color: #94a3b8; font-weight: 500; }

  /* ── Process Steps ── */
  .sg-process-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); }
  .sg-steps { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; position: relative; }
  @media (max-width: 900px) { .sg-steps { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 580px) { .sg-steps { grid-template-columns: 1fr; } }
  .sg-steps::before { content: ''; position: absolute; top: 32px; left: calc(12.5% + 8px); right: calc(12.5% + 8px); height: 2px; background: linear-gradient(90deg, #1e4d8c, #c9931a); z-index: 0; opacity: 0.25; }
  @media (max-width: 900px) { .sg-steps::before { display: none; } }
  .sg-step { text-align: center; position: relative; z-index: 1; }
  .sg-step-num { width: 64px; height: 64px; border-radius: 50%; background: linear-gradient(135deg, #0c1a36, #1e4d8c); color: #fff; font-size: 1.35rem; font-weight: 900; display: flex; align-items: center; justify-content: center; margin: 0 auto 24px; box-shadow: 0 8px 24px rgba(12,26,54,0.3); }
  .sg-step h3 { font-size: 1.02rem; font-weight: 700; color: #0c1a36; margin-bottom: 12px; }
  .sg-step p { font-size: 0.87rem; color: #64748b; line-height: 1.72; max-width: 220px; margin: 0 auto; }
  .sg-step-chip { display: inline-block; margin-bottom: 18px; padding: 4px 12px; border-radius: 999px; background: #fef3c7; border: 1px solid #fde68a; font-size: 11px; font-weight: 700; color: #92400e; letter-spacing: 0.04em; }

  /* ── Benefits (white) ── */
  .sg-benefits-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px; }
  @media (max-width: 640px) { .sg-benefits-grid { grid-template-columns: 1fr; } }
  .sg-benefit-card { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 20px; padding: 32px 36px; display: flex; gap: 20px; align-items: flex-start; transition: all 0.3s; }
  .sg-benefit-card:hover { background: #fff; box-shadow: 0 14px 44px rgba(0,0,0,0.07); border-color: #e2e8f0; transform: translateY(-2px); }
  .sg-benefit-icon { flex-shrink: 0; width: 52px; height: 52px; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 22px; }
  .sg-benefit-icon.navy   { background: #eff4ff; }
  .sg-benefit-icon.gold   { background: #fef3c7; }
  .sg-benefit-icon.green  { background: #ecfdf5; }
  .sg-benefit-icon.teal   { background: #f0fdfa; }
  .sg-benefit-card h4 { font-size: 1.05rem; font-weight: 700; color: #0c1a36; margin-bottom: 8px; }
  .sg-benefit-card p { font-size: 0.9rem; color: #64748b; line-height: 1.72; }

  /* ── Testimonials ── */
  .sg-testimonials-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .sg-tgrid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 960px) { .sg-tgrid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .sg-tgrid { grid-template-columns: 1fr; } }
  .sg-tcard { background: #fff; border: 1px solid #f1f5f9; border-radius: 20px; padding: 32px; transition: all 0.3s; display: flex; flex-direction: column; }
  .sg-tcard:hover { box-shadow: 0 14px 44px rgba(0,0,0,0.08); border-color: #e2e8f0; }
  .sg-stars { color: #d97706; font-size: 14px; letter-spacing: 2px; margin-bottom: 16px; }
  .sg-tcard-text { font-size: 0.92rem; color: #334155; line-height: 1.78; font-style: italic; margin-bottom: 24px; flex: 1; }
  .sg-tcard-author { display: flex; align-items: center; gap: 12px; }
  .sg-author-avatar { width: 44px; height: 44px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 15px; font-weight: 700; color: #fff; flex-shrink: 0; }
  .sg-author-name { font-size: 13.5px; font-weight: 700; color: #0c1a36; }
  .sg-author-role { font-size: 12px; color: #94a3b8; margin-top: 1px; }
  .sg-tcard-badge { display: inline-flex; align-items: center; gap: 5px; margin-bottom: 18px; padding: 4px 10px; border-radius: 999px; background: #fef3c7; border: 1px solid #fde68a; font-size: 11px; font-weight: 600; color: #92400e; }

  /* ── CTA ── */
  .sg-cta-bg { background: #fff; border-top: 1px solid #f1f5f9; }
  .sg-cta-inner { background: linear-gradient(135deg, #0c1a36 0%, #1a3568 60%, #0c1a36 100%); border-radius: 32px; padding: 92px 56px; text-align: center; position: relative; overflow: hidden; max-width: 1000px; margin: 0 auto; }
  @media (max-width: 640px) { .sg-cta-inner { padding: 52px 28px; border-radius: 24px; } }
  .sg-cta-glow1 { position: absolute; top: -20%; right: -5%; width: 400px; height: 400px; background: radial-gradient(circle, rgba(201,147,26,0.22), transparent 65%); pointer-events: none; }
  .sg-cta-glow2 { position: absolute; bottom: -20%; left: -5%; width: 400px; height: 400px; background: radial-gradient(circle, rgba(30,77,140,0.35), transparent 65%); pointer-events: none; }
  .sg-cta-inner h2 { font-size: clamp(2rem, 4vw, 3rem); font-weight: 900; color: #fff; letter-spacing: -0.03em; line-height: 1.15; margin-bottom: 18px; position: relative; z-index: 1; }
  .sg-cta-inner > p { font-size: 1.1rem; color: #94a3b8; font-weight: 300; max-width: 560px; margin: 0 auto 40px; line-height: 1.78; position: relative; z-index: 1; }
  .sg-cta-btns { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; margin-bottom: 32px; }
  .sg-cta-primary { padding: 15px 34px; background: #c9931a; color: #fff; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: background 0.2s, transform 0.15s; box-shadow: 0 4px 20px rgba(201,147,26,0.4); }
  .sg-cta-primary:hover { background: #e0a820; transform: translateY(-1px); }
  .sg-cta-secondary { padding: 15px 34px; background: rgba(255,255,255,0.07); color: #cbd5e1; border: 1px solid rgba(255,255,255,0.15); border-radius: 12px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .sg-cta-secondary:hover { background: rgba(255,255,255,0.13); color: #fff; }
  .sg-cta-trust { display: flex; align-items: center; justify-content: center; gap: 28px; flex-wrap: wrap; position: relative; z-index: 1; }
  .sg-cta-trust-item { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #64748b; }
  .sg-cta-trust-item .check { color: #fbbf24; font-weight: 800; }
`;

const fadeUp = {
  initial: { opacity: 0, y: 32 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-50px' },
  transition: { duration: 0.6 },
};

const stagger = (i: number) => ({
  ...fadeUp,
  transition: { duration: 0.55, delay: i * 0.1 },
});

const services = [
  {
    color: 'c-navy',
    icon: '🪪',
    title: 'UEI Number Application',
    slug: 'uei-application',
    description:
      'We handle the full Unique Entity Identifier (UEI) application on your behalf — eliminating confusion, preventing common errors, and ensuring your identifier is issued without delay.',
    tags: ['UEI Issuance', 'Error-Free Filing', 'Fast Turnaround'],
  },
  {
    color: 'c-blue',
    icon: '🏛️',
    title: 'SAM.gov Profile Setup',
    slug: 'profile-setup',
    description:
      "Our specialists configure your complete SAM.gov profile — CAGE code, NAICS codes, PSC codes, and all entity details — so you're immediately eligible to receive contract awards.",
    tags: ['CAGE Code', 'NAICS Codes', 'Full Profile Build'],
  },
  {
    color: 'c-gold',
    icon: '🔄',
    title: 'Annual Renewal Management',
    slug: 'annual-renewal',
    description:
      'Your SAM.gov registration expires every year. We track your renewal date, manage the update process, and ensure your record stays active so you never lose contracting eligibility.',
    tags: ['Renewal Alerts', 'Profile Updates', 'Continuous Compliance'],
  },
  {
    color: 'c-teal',
    icon: '✅',
    title: 'Entity Validation & Compliance',
    slug: 'entity-validation',
    description:
      'We audit your entity information against IRS, CAGE, and DUNS records to resolve mismatches before they cause registration rejections or payment delays from federal agencies.',
    tags: ['IRS Validation', 'Record Matching', 'Rejection Prevention'],
  },
  {
    color: 'c-indigo',
    icon: '📋',
    title: 'NAICS & PSC Code Selection',
    slug: 'profile-setup',
    description:
      'Selecting the right industry codes determines which solicitations you appear in. We research and assign the optimal NAICS and PSC codes aligned to your capabilities and target agencies.',
    tags: ['Market Alignment', 'Code Research', 'Opportunity Maximization'],
  },
  {
    color: 'c-emerald',
    icon: '🤝',
    title: 'Certifications & Representations',
    slug: 'certifications',
    description:
      'We complete your SAM.gov representations and certifications — including small business, veteran-owned, woman-owned, and HUBZone status — to unlock set-aside contract opportunities.',
    tags: ['Small Business', 'Veteran-Owned', 'HUBZone', 'WOSB'],
  },
];

const processSteps = [
  {
    num: '01',
    chip: 'Day 1',
    title: 'UEI Acquisition',
    description:
      'We apply for your Unique Entity Identifier through SAM.gov — typically issued within 24–48 hours.',
  },
  {
    num: '02',
    chip: 'Day 1–2',
    title: 'Document Preparation',
    description:
      'We gather and verify your CAGE code, tax information, NAICS codes, and business entity details.',
  },
  {
    num: '03',
    chip: 'Day 2–3',
    title: 'Registration Completion',
    description:
      'We complete your SAM.gov profile, representations, and certifications with zero errors.',
  },
  {
    num: '04',
    chip: 'Day 3–5',
    title: 'Activation & Monitoring',
    description:
      'We submit, monitor for approval, and confirm your active status — then set up renewal reminders.',
  },
];

const whyItems = [
  {
    icon: '🏗️',
    color: 'gold',
    title: 'Required for All Federal Contracts',
    desc: 'Every business that wants to sell goods or services to the U.S. federal government must be registered and active in SAM.gov. There is no workaround.',
  },
  {
    icon: '💵',
    color: 'blue',
    title: 'Unlocks Billions in Contract Spending',
    desc: 'The federal government spends over $650 billion per year on contracts. SAM.gov registration is the single gateway to accessing that market.',
  },
  {
    icon: '📅',
    color: 'green',
    title: 'Must Be Renewed Annually',
    desc: 'Registrations expire every 12 months. A lapsed registration means you cannot receive payment on existing contracts or compete for new awards.',
  },
  {
    icon: '⚡',
    color: 'teal',
    title: 'Errors Cause Costly Delays',
    desc: 'Data mismatches between SAM.gov and IRS or CAGE records can trigger rejection or payment blocks. Expert guidance prevents these costly mistakes.',
  },
];

const benefits = [
  {
    icon: '⚡',
    color: 'navy',
    title: 'Fast 48–72 Hour Processing',
    desc: 'Most registrations are active within 2–3 business days. We eliminate back-and-forth with step-by-step precision so nothing slows your timeline down.',
  },
  {
    icon: '🎯',
    color: 'gold',
    title: '98% First-Submission Accuracy',
    desc: 'We have processed over 500 registrations with a 98% first-submission approval rate — no rejections, no rework, no wasted time.',
  },
  {
    icon: '🔔',
    color: 'green',
    title: 'Renewal Monitoring & Alerts',
    desc: 'We track your expiration date and notify you 90, 60, and 30 days in advance so your registration is never allowed to lapse.',
  },
  {
    icon: '🛡️',
    color: 'teal',
    title: 'Compliance Guarantee',
    desc: 'If your registration is ever flagged for a compliance issue we handled, we correct it at no additional charge — our commitment to your federal eligibility.',
  },
];

const testimonials = [
  {
    badge: 'Defense Contractor',
    stars: '★★★★★',
    text: '"BizServe had us fully registered on SAM.gov in under 3 days. We bid on our first SBIR contract the following week. The process we had been dreading turned out to be painless."',
    name: 'Marcus T.',
    role: 'CEO, Tactix Engineering LLC',
    avatarBg: '#1e4d8c',
    initials: 'MT',
  },
  {
    badge: 'IT Services',
    stars: '★★★★★',
    text: '"Our registration had lapsed and we were blocked from payment on an active contract. BizServe got us back in compliance in 48 hours. That responsiveness saved us a real headache."',
    name: 'Priya S.',
    role: 'Director, CloudPath Federal',
    avatarBg: '#c9931a',
    initials: 'PS',
  },
  {
    badge: 'Veteran-Owned Business',
    stars: '★★★★★',
    text: '"As a veteran-owned business, I needed the right certifications set up in SAM.gov to compete for set-aside contracts. The team knew exactly what codes to use and got everything right the first time."',
    name: 'James R.',
    role: 'Owner, Eagle Point Services',
    avatarBg: '#059669',
    initials: 'JR',
  },
];

const SAMGov = () => {
  const { navigateTo } = useNavigation();

  return (
    <>
      <style>{styles}</style>
      <div className="sg-page">

        {/* ── Hero ── */}
        <section className="sg-hero">
          <div className="sg-hero-blob1" />
          <div className="sg-hero-blob2" />
          <div className="sg-hero-inner">
            <motion.div {...fadeUp}>
              <div className="sg-badge">
                <span className="sg-badge-star">★</span>
                Authorized Federal Registration Specialists
              </div>
              <h1>
                Unlock Federal Contracts.<br />
                <span className="sg-gradient-text">Get Registered on SAM.gov Today.</span>
              </h1>
              <p className="sg-hero-sub">
                Your Unique Entity Identifier (UEI) and active SAM.gov registration are
                mandatory to compete for — and get paid on — any U.S. federal contract.
                We handle the entire process so you can focus on winning business.
              </p>
              <div className="sg-btn-group">
                <button className="sg-btn-primary">
                  Start My Registration →
                </button>
                <button className="sg-btn-secondary">
                  See How It Works
                </button>
              </div>
            </motion.div>

            {/* Portal Mock Card */}
            <motion.div
              className="sg-hero-visual"
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              style={{ position: 'relative' }}
            >
              <div className="sg-portal-card">
                <div className="sg-portal-dots" />
                <div className="sg-portal-header">
                  <div className="sg-portal-logo">🏛️</div>
                  <div>
                    <div className="sg-portal-title">SAM.gov Registration Portal</div>
                    <div className="sg-portal-subtitle">System for Award Management</div>
                  </div>
                  <div className="sg-portal-status">
                    <div className="sg-portal-dot" />
                    Active
                  </div>
                </div>

                <div className="sg-portal-field">
                  <div className="sg-portal-field-label">Unique Entity ID (UEI)</div>
                  <div className="sg-portal-field-value">ABCXYZ123456</div>
                </div>
                <div className="sg-portal-field">
                  <div className="sg-portal-field-label">CAGE Code</div>
                  <div className="sg-portal-field-value">7K2F9</div>
                </div>
                <div className="sg-portal-field">
                  <div className="sg-portal-field-label">Entity Validation</div>
                  <div className="sg-portal-field-value verified">✓ IRS Validated · CAGE Confirmed</div>
                </div>

                <div className="sg-portal-progress-wrap">
                  <div className="sg-portal-progress-top">
                    <span className="sg-portal-progress-label">Registration Completion</span>
                    <span className="sg-portal-progress-pct">82%</span>
                  </div>
                  <div className="sg-progress-bar">
                    <div className="sg-progress-fill" />
                  </div>
                  <div className="sg-portal-steps">
                    <span className="sg-portal-step-chip done">✓ UEI Issued</span>
                    <span className="sg-portal-step-chip done">✓ CAGE Verified</span>
                    <span className="sg-portal-step-chip active">⟳ Filing Profile</span>
                    <span className="sg-portal-step-chip pending">Activation</span>
                  </div>
                </div>
              </div>

              <div className="sg-floating-badge">
                <div className="sg-fb-icon">🏆</div>
                <div>
                  <div className="sg-fb-label">Contracts Unlocked</div>
                  <div className="sg-fb-value">$50M+ Awarded</div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* ── Stats Bar ── */}
        <section className="sg-stats">
          <div className="sg-stats-grid">
            {[
              { num: '500+', label: 'Successful Registrations' },
              { num: '$50M+', label: 'Client Contracts Awarded' },
              { num: '98%', label: 'First-Submission Success Rate' },
              { num: '48–72 hrs', label: 'Average Processing Time' },
            ].map((s, i) => (
              <motion.div key={i} className="sg-stat-item" {...stagger(i)}>
                <div className="sg-stat-num">{s.num}</div>
                <div className="sg-stat-label">{s.label}</div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* ── Services ── */}
        <section className="sg-section sg-services-bg">
          <div className="sg-container">
            <motion.div className="sg-section-header" {...fadeUp}>
              <div className="sg-kicker">What We Do</div>
              <h2>Complete SAM.gov Registration Services</h2>
              <p>
                From obtaining your UEI to activating your full profile and certifications —
                we handle every step of the federal registration process with precision.
              </p>
            </motion.div>
            <div className="sg-services-grid">
              {services.map((s, i) => (
                <motion.div
                  key={i}
                  className={`sg-svc-card ${s.color}`}
                  {...stagger(i)}
                  onClick={() => navigateTo(s.slug)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className={`sg-svc-icon ${s.color}`}>{s.icon}</div>
                  <h3>{s.title}</h3>
                  <p>{s.description}</p>
                  <div className="sg-svc-tags">
                    {s.tags.map((t, j) => (
                      <span key={j} className="sg-svc-tag">{t}</span>
                    ))}
                  </div>
                  <span className="sg-svc-arrow">Learn More →</span>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Why SAM.gov Matters ── */}
        <section className="sg-section sg-why-bg">
          <div className="sg-why-glow1" />
          <div className="sg-why-glow2" />
          <div className="sg-container">
            <div className="sg-why-grid">
              <motion.div className="sg-why-left" {...fadeUp}>
                <div className="sg-kicker" style={{ color: '#fbbf24' }}>Why It Matters</div>
                <h2>SAM.gov Is the Gateway to the Federal Marketplace</h2>
                <p>
                  The U.S. federal government is the world's largest buyer of goods and services.
                  But to participate, your business must be registered and in good standing on
                  SAM.gov — no exceptions.
                </p>
                <div className="sg-why-list">
                  {whyItems.map((item, i) => (
                    <div key={i} className="sg-why-item">
                      <div className={`sg-why-icon ${item.color}`}>{item.icon}</div>
                      <div>
                        <h4>{item.title}</h4>
                        <p>{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </motion.div>

              <motion.div className="sg-why-right" {...stagger(1)}>
                {[
                  { num: '$650B+', color: 'gold', label: 'Annual Federal Contract Spending' },
                  { num: '170,000+', color: 'blue', label: 'Active Contract Opportunities Per Year' },
                  { num: '23%', color: 'green', label: 'Set Aside Exclusively for Small Businesses' },
                ].map((s, i) => (
                  <div key={i} className="sg-why-stat-card">
                    <div className={`sg-why-stat-num ${s.color}`}>{s.num}</div>
                    <div className="sg-why-stat-label">{s.label}</div>
                  </div>
                ))}
              </motion.div>
            </div>
          </div>
        </section>

        {/* ── Process ── */}
        <section className="sg-section sg-process-bg">
          <div className="sg-container">
            <motion.div className="sg-section-header" {...fadeUp}>
              <div className="sg-kicker">Our Process</div>
              <h2>Registered & Active in 4 Simple Steps</h2>
              <p>
                We manage the entire SAM.gov registration process — from UEI issuance to
                final activation — with a clear, proven workflow designed for speed and accuracy.
              </p>
            </motion.div>
            <div className="sg-steps">
              {processSteps.map((step, i) => (
                <motion.div key={i} className="sg-step" {...stagger(i)}>
                  <div className="sg-step-num">{step.num}</div>
                  <div className="sg-step-chip">{step.chip}</div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Benefits ── */}
        <section className="sg-section" style={{ background: '#fff' }}>
          <div className="sg-container">
            <motion.div className="sg-section-header" {...fadeUp}>
              <div className="sg-kicker">Why Choose Us</div>
              <h2>The BizServe Advantage for Federal Registration</h2>
              <p>
                We've helped over 500 businesses get registered, stay compliant, and compete
                with confidence in the federal marketplace. Here's what sets us apart.
              </p>
            </motion.div>
            <div className="sg-benefits-grid">
              {benefits.map((b, i) => (
                <motion.div key={i} className="sg-benefit-card" {...stagger(i)}>
                  <div className={`sg-benefit-icon ${b.color}`}>{b.icon}</div>
                  <div>
                    <h4>{b.title}</h4>
                    <p>{b.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Testimonials ── */}
        <section className="sg-section sg-testimonials-bg">
          <div className="sg-container">
            <motion.div className="sg-section-header" {...fadeUp}>
              <div className="sg-kicker">Client Results</div>
              <h2>Trusted by Federal Contractors Across Industries</h2>
              <p>
                Hear from businesses that used BizServe to navigate SAM.gov and start winning
                government contracts faster.
              </p>
            </motion.div>
            <div className="sg-tgrid">
              {testimonials.map((t, i) => (
                <motion.div key={i} className="sg-tcard" {...stagger(i)}>
                  <div className="sg-tcard-badge">✦ {t.badge}</div>
                  <div className="sg-stars">{t.stars}</div>
                  <p className="sg-tcard-text">{t.text}</p>
                  <div className="sg-tcard-author">
                    <div
                      className="sg-author-avatar"
                      style={{ background: t.avatarBg }}
                    >
                      {t.initials}
                    </div>
                    <div>
                      <div className="sg-author-name">{t.name}</div>
                      <div className="sg-author-role">{t.role}</div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* ── CTA ── */}
        <section className="sg-section sg-cta-bg">
          <div className="sg-container">
            <motion.div className="sg-cta-inner" {...fadeUp}>
              <div className="sg-cta-glow1" />
              <div className="sg-cta-glow2" />
              <h2>
                Ready to Enter the<br />Federal Marketplace?
              </h2>
              <p>
                Get your SAM.gov registration handled by specialists who do this every day.
                Fast, accurate, and fully managed — start today.
              </p>
              <div className="sg-cta-btns">
                <button className="sg-cta-primary">
                  Start My Registration →
                </button>
                <button className="sg-cta-secondary">
                  Schedule a Free Consultation
                </button>
              </div>
              <div className="sg-cta-trust">
                <span className="sg-cta-trust-item"><span className="check">★</span> 98% First-Submission Success</span>
                <span className="sg-cta-trust-item"><span className="check">★</span> 500+ Registrations Completed</span>
                <span className="sg-cta-trust-item"><span className="check">★</span> Compliance Guarantee</span>
              </div>
            </motion.div>
          </div>
        </section>

      </div>
    </>
  );
};

export default SAMGov;
